import React, { useState, useEffect, useRef } from "react";
import { func, bool, array, string, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";
import Cookies from "universal-cookie";

import HamburgerIcon from "../../atoms/icons/hamburger";
import NavbarSearch from "../NavbarSearch";
import MobileLogo from "../../atoms/MobileLogo";
import SearchIcon from "../../atoms/icons/search-icon";
import AuthView from "../../rows/AuthView";
import VerticalMenubar from "../VerticalMenubar";
import Icon from "../../icons";
import { Facebook, Twitter } from "../../atoms/icons/StoryPageIcons";

import { setVerticalMenuBar } from "../../helper/actions";
import { useStyleMenubar, useDeviceWidth, logoRenderer } from "../../utils/react-utils";
import Notifications from "../Notifications";
import { pushEngage } from "../../helper/api";
import { getCurrentSite } from "../../utils/utils";

import "./defaultHeader.m.css";

const DefaultHeader = ({
  isVerticalMenubar,
  setVerticalMenuBar,
  stickyHeader = false,
  domainInfo,
  domainSlug = "",
  hamburgerMenu,
  pushEngageApiKey,
  publisherAttributes,
  currentPath
}) => {
  const [isDesktop, setIsDesktop] = useState(false);
  const [showSearchIcon, setShowSearchIcon] = useState(true);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [dot, setDot] = useState(false);
  const cookies = new Cookies();
  const ref = useRef(null);
  const handleClickOutside = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      setShowSearchIcon(true);
    }
  };

  const fetchNotifications = () => {
    const offset = 0;
    const limit = 4;

    pushEngage(offset, limit, pushEngageApiKey).then(resp => {
      setNotifications(resp);
      if (cookies.get("notifications") && resp.length > 0) {
        resp[0].notification_id !== cookies.get("notifications") ? setDot(true) : setDot(false);
      } else {
        setNotifications(resp);
        resp.length > 0 && setDot(true);
      }
    });
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(() => {
      fetchNotifications();
    }, 150000);

    return () => clearInterval(interval);
  }, []);

  useDeviceWidth(setIsDesktop);
  useStyleMenubar(isVerticalMenubar);

  const toggleSearchIcon = () => setShowSearchIcon(!showSearchIcon);
  const toggleVerticalMenubar = () => setVerticalMenuBar(!isVerticalMenubar);

  const toggleNotifications = () => {
    if (!showNotifications) {
      cookies.set("notifications", notifications.length && notifications[0].notification_id);
      setDot(false);
    }

    setShowNotifications(!showNotifications);
  };

  const currentSite = getCurrentSite(currentPath);

  const isDomain = () => {
    const multiDomainNames = ["kishoralo", "bondhushava", "protichinta", "bigganchinta", "trust", "nagorik"];
    return multiDomainNames.includes(currentSite);
  };

  return (
    <div styleName="base">
      <div
        styleName={`wrapper ${domainInfo && domainInfo.className ? domainInfo.className : ""} ${
          stickyHeader ? "sticky-header" : ""
        } ${currentPath && isDomain() ? currentSite + "-section-header" : ""}`}
        className="header-top-content"
      >
        <div>
          <div styleName="hamburger-search-wrapper" className="hamburger-search-wrapper">
            {!isVerticalMenubar && !currentPath && (
              <HamburgerIcon
                onMenuToggle={toggleVerticalMenubar}
                isNavbarOpen={!!isVerticalMenubar}
                isDesktop={isDesktop}
              />
            )}
            {domainSlug !== "protichinta" && isDesktop && showSearchIcon && !stickyHeader && (
              <span styleName="search-icon" onClick={toggleSearchIcon}>
                <SearchIcon domainSlug={domainSlug} />
              </span>
            )}
            {domainSlug !== "protichinta" && isDesktop && !stickyHeader && (
              <span ref={ref}>{!showSearchIcon && <NavbarSearch />}</span>
            )}
          </div>
          {isVerticalMenubar && (
            <VerticalMenubar
              isVerticalMenubar={isVerticalMenubar}
              isDesktop={isDesktop}
              toggleVerticalMenubar={toggleVerticalMenubar}
              hamburgerMenu={hamburgerMenu}
            />
          )}
        </div>
        <div styleName={`logo ${isVerticalMenubar ? "vertical-menu-bar-logo" : ""}`}>
          {logoRenderer(<MobileLogo />, currentPath)}
        </div>
        {!stickyHeader && (
          <div styleName="login-wrapper">
            <div styleName="bell-button">
              {domainSlug === "protichinta" && isDesktop && (
                <span styleName="protichinta-icons">
                  {showSearchIcon && (
                    <span styleName="protichinta-search-icon" onClick={toggleSearchIcon}>
                      <SearchIcon domainSlug={domainSlug} width="18" height="18" />
                    </span>
                  )}
                  <span ref={ref}>{!showSearchIcon && <NavbarSearch />}</span>
                  <Link href="https://www.facebook.com/Protichinta/">
                    <Facebook color1="#fbf6de" color2="#555555" />
                  </Link>
                  <Link href="https://twitter.com/Protichinta">
                    <Twitter color1="#fbf6de" color2="#555555" />
                  </Link>
                </span>
              )}
              <div styleName={`bell-container ${dot ? "new-notifications" : "no-notifications"}`}>
                <span styleName="bell" onClick={() => toggleNotifications()}>
                  {" "}
                  <Icon type="bell" className="bell" />
                </span>
                {showNotifications && <Notifications closeView={toggleNotifications} notifications={notifications} />}
              </div>
              {publisherAttributes.showLogin && <AuthView />}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

DefaultHeader.propTypes = {
  setVerticalMenuBar: func,
  isVerticalMenubar: bool,
  stickyHeader: bool,
  domainInfo: object,
  domainSlug: string,
  hamburgerMenu: array,
  pushEngageApiKey: string,
  publisherAttributes: object,
  currentPath: string
};

const mapStateToProps = state => ({
  isVerticalMenubar: get(state, ["settingsReducer", "isVerticalMenubar"], false),
  domainSlug: get(state, ["qt", "domainSlug"]),
  pushEngageApiKey: get(state, ["qt", "config", "publisher-attributes", "push_engage_api_key"], null),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  currentPath: get(state, ["currentPathReducer", "currentPath"], null)
});

const mapDispatchToProps = dispatch => ({
  setVerticalMenuBar: flag => dispatch(setVerticalMenuBar(flag))
});

export default connect(mapStateToProps, mapDispatchToProps)(DefaultHeader);
